import { NEW_MESSAGE } from '../constants';

export const newMessage = (channel, message) => async (dispatch) => {
  return dispatch({type: NEW_MESSAGE, payload: {
    channel, message
  }});
}